import type { CSSProperties } from 'react'
import type { BookingSource } from '@/shared/api'
import s from './SourceBadge.module.css'

type SourceBadgeProps = {
  source: BookingSource
}

/**
 * Бейдж происхождения брони (prototype/Prototype.dc.html:592) — название площадки на её же тоне.
 *
 * ⚠️ ПРИВАТНЫХ СЛОВАРЕЙ ПЛОЩАДОК ЗДЕСЬ БЫТЬ НЕ ДОЛЖНО — ни двухбуквенных кодов («RC», «AV»), ни
 * полных имён («RealtyCalendar», «Авито»). Справочник домена засеян, незнакомая площадка заводится
 * автоматически, и со словарём новая рисовалась бы прочерком до ближайшего деплоя фронта.
 * ⚠️ Объяснение «сервер названия источника не присылает» когда-то было правдой — из-за дефекта на
 * их стороне площадка приходила пустой у 100% броней. Дефект починен: такие оговорки в комментариях
 * стоит перечитывать после каждого письма от команды.
 *
 * Короткий код при этом исчез не по недосмотру: у домена его нет. Придумать его самим значило бы
 * завести третий словарь — и на первой же незнакомой площадке он ответил бы пустотой. Показываем
 * то, что сервер и правда знает: имя.
 *
 * ⚠️ ЦВЕТ ПРИХОДИТ С СЕРВЕРА, И ЭТО ЕДИНСТВЕННОЕ ТАКОЕ МЕСТО. Он не наша палитра, а свойство
 * ЧУЖОГО БРЕНДА: держать «зелёный Авито» у себя значило бы заводить строку на каждый новый Airbnb.
 * Но проверить его контраст-гейтом невозможно — гейт знает только наши токены, а тут произвольное
 * значение. Поэтому применяем его ОДНИМ безопасным способом: подмешиванием малой доли в фон
 * (`color-mix` 14%), где светлота результата ограничена подложкой независимо от входа. Чернила
 * поверх читаются при ЛЮБОМ цвете, включая чёрный и белый, — и оба крайних случая посчитаны
 * гейтом (`tools/contrast.mjs`, пары «чернила на чёрном/белом с сервера»).
 *
 * Цветом ТЕКСТА и сплошной заливкой это значение не становится нигде: там читаемость зависела бы
 * от того, что прислал сервер.
 */
export function SourceBadge({ source }: SourceBadgeProps) {
  return (
    <span className={s.root} style={{ '--pf': source.color } as CSSProperties} title={source.name}>
      <span className={s.name}>{source.name}</span>
    </span>
  )
}
